import React, { useEffect } from 'react';

import { Checkbox, Row, Col, Radio } from 'react-bootstrap';

import Loading from '../../components/shared/Loading';

import { commifyNumber } from '../../utils/utilities';
import featureFlags from '../../utils/featureFlags';
import ExcessPremiumGrid from './ExcessPremiumGrid';
import Limits from './Limits';

const ExcessQuote = (props) => {
  const {
    isModified,
    submission,
    rating,
    handleExcessCheck,
    manuallySetPricing,
    onBlurHandler,
    pricingValues,
    isUnderwriter,
    updatePricingOptions,
  } = props;
  const { excessTerrorPremium, excessPremium, totalExcessPremium } = pricingValues;
  const { terror = {} } = submission?.coverages?.gl?.additional ?? {};

  const referralCarriers = ['argo', 'colony', 'peleus'];
  const checkCarrier = (val) =>
    !/^\s+$/.test(submission.generalLiabilityCarrier) &&
    submission.generalLiabilityCarrier
      .toLowerCase()
      .trim()
      .match(/[^\s]+/)[0] === val;

  useEffect(() => {
    updateExcessPricingOptions();
  }, [submission?.excessLimitAmount, terror?.selected]);

  const updateExcessPricingOptions = () => {
    updatePricingOptions([
      {
        key: 'totalExcessPremium',
        label: 'Total Excess Premium',
        required: submission.excessLimitAmount != 'noExcess',
      },
      {
        key: 'excessPremium',
        label: 'Base Excess Premium',
        required: submission.excessLimitAmount != 'noExcess',
      },
      {
        key: 'excessTerrorPremium',
        label: 'Excess TRIA',
        required: submission.excessLimitAmount != 'noExcess' && terror.selected,
      },
    ]);
  };

  return (
    <div>
      <Row>
        <Col xs={8} md={6}>
          <Checkbox
            onChange={handleExcessCheck}
            checked={submission.excessLimitAmount !== 'noExcess'}
            value="noExcess"
            disabled={
              !isUnderwriter &&
              submission.generalLiabilityCarrier &&
              referralCarriers.some(checkCarrier)
            }
            className="excessCheckBox"
          >
            Offer an Excess Quote
          </Checkbox>
        </Col>
      </Row>
      {submission.excessLimitAmount != 'noExcess' && (
        <div>
          <Limits
            defaultValue={submission.excessLimitAmount}
            onChange={handleExcessCheck}
            name="excessQuoteLimits"
            type={submission.type}
            values={submission}
          />
          {(rating || manuallySetPricing) && (
            <div>
              <ExcessPremiumGrid
                excessTerrorPremium={excessTerrorPremium}
                excessPremium={excessPremium}
                isModified={isModified}
                submission={submission}
                manuallySetPricing={manuallySetPricing}
                onBlurHandler={onBlurHandler}
              />
              <Row>
                <Col xs={8} md={6}>
                  <div className="total-premium-row">
                    <div className="h4">Total Excess Premium</div>
                    <div className="h1 total-excess-premium">
                      {isModified ? (
                        <Loading width="47px" height="47px" />
                      ) : (
                        <span>${commifyNumber(totalExcessPremium || 0)}</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ExcessQuote;
